import React from "react"
import styled from "styled-components"
import { Paper } from "@mui/material"
import { useTheme } from "@mui/material/styles"

const HorizontalTargetBarWrap = styled(Paper)`
  // border: 1px solid ${p => p.theme.basePalette.fg};
  height: 20px;
  position: relative;
  padding: 0;

  > div {
    background: ${p => p.theme.palette.primary.main};
  }

  > span {
    border: 1px dashed ${p => p.theme.basePalette.fg};
  }
`
const BarFill = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
`

const TargetLine = styled.span`
  position: absolute;
  top: -20%;
  height: 140%;
  width: 1px;
`

export default function HorizontalTargetBar({
  width = "100%",
  value = 0,
  max = 100,
  target = null
}) {
  const theme = useTheme()
  const styles = {
    width
  }
  const fillWidth = (100 * value) / max
  const isTargetActive = !Number.isNaN(target) && target >= 0 && target <= max
  const targetWidth = isTargetActive ? (100 * target) / max : 0

  return (
    <HorizontalTargetBarWrap style={styles} theme={theme}>
      <BarFill style={{ width: `${fillWidth}%` }} />
      {isTargetActive ? <TargetLine style={{ left: `${targetWidth}%` }} /> : ""}
    </HorizontalTargetBarWrap>
  )
}
